<template>
  <w-modal
    v-model="show"
    close-button="Anuluj"
    submit-button="Zapisz"
    title="Zmiana hasła"
    :close-on-submit="false"
    :hide-on-overlay="false"
    :hide-on-esc="false"
    :show-footer="false"
    @close="close"
  >
    <password-form button-text="Ustaw" with-current-password @setPassword="setPassword" />
  </w-modal>
</template>

<script>
import PasswordForm from '@/components/forms/PasswordForm';
import { modalMixin } from '@/mixins/modal';
import { notificationsMixin } from '@/mixins/notifications';
import { serverError } from '@/utils/serverError';

// @vuese
// Modal zmiany hasła zalogowanego użytkownika
// @group modals
export default {
  components: {
    PasswordForm
  },
  mixins: [modalMixin, notificationsMixin],

  methods: {
    // @vuese
    // Wysłanie zapytania ze zmianą hasła
    setPassword(data) {
      this.$store
        .dispatch('auth/setPasswordLogged', data)
        .then(() => {
          this.notifySuccess('Ustawiono nowe hasło');
          this.$emit('close');
        })
        .catch(error => {
          this.notifyError(serverError(error));
        });
    }
  }
};
</script>
